import React, { useState } from "react";
import { update_username, update_pass } from "../../redux/actions/adminActions";
import { motion } from "framer-motion";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import InputField from "../reusables/input";
import { connect } from "react-redux";

function Profile({
  adminEmail,
  adminUsername,
  updateUsername,
  accessToken,
  updatePassword,
}) {
  const [changed, setChange] = useState(false);

  const [profileData, setProfile] = useState({
    username: adminUsername,
    email: adminEmail,
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  const handleChange = (e) => {
    setProfile({
      ...profileData,
      [e.target.name]: e.target.value,
    });
    setChange(true);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    updateUsername(accessToken, profileData.username);
  };

  const handleSubmit = (e) => {
    let body = {
      old_password: profileData?.old_password,
      new_password: profileData?.new_password,
      confirm_new_password: profileData?.confirm_new_password,
    };
    e.preventDefault();
    updatePassword(accessToken, body);
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5">
            <div className="py-3">
              <h2 className="sectionText--mid textIsBold">
                ACCOUNT INFORMATION
              </h2>

              <div className="pt-3">
                <form className="" onSubmit={handleUpdate}>
                  <InputField
                    label="Username"
                    value={profileData.username}
                    name="username"
                    onChange={handleChange}
                  />
                  <div className="my-3">
                    <InputField
                      label="Email"
                      value={profileData.email}
                      disabled
                    />
                  </div>
                  <button
                    className={`mt-3 hasRadius ${
                      changed ? "btn__filled" : "btn__disabled"
                    }`}
                    disabled={!changed}
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>

            <div className="py-3">
              <h2 className="sectionText--mid textIsBold mb-1">
                CHANGE PASSWORD
              </h2>

              <div className="">
                <form className="py-2" onSubmit={handleSubmit}>
                  <div className="my-3">
                    <InputField
                      label="Old Password"
                      value={profileData.old_password}
                      name="old_password"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="my-3">
                    <InputField
                      label="New Password"
                      value={profileData.new_password}
                      name="new_password"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="my-3">
                    <InputField
                      label="Confirm New Password"
                      value={profileData.confirm_new_password}
                      name="confirm_new_password"
                      onChange={handleChange}
                    />
                  </div>

                  <button className="btn__filled hasRadius mt-3">Save</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  adminEmail: state.admin.currentAdmin.email,
  adminUsername: state.admin.currentAdmin.username,
});

const mapDispatchToProps = (dispatch) => ({
  updateUsername: (token, username) =>
    dispatch(update_username(token, username)),
  updatePassword: (token, data) => dispatch(update_pass(token, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
